exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@keyframes animatedgradient{}.main-content-container.attendance-page{padding:0}.main-content-container.attendance-page .tcf-calendar-wrapper{margin-bottom:15px}.attendance-page__main{width:100%;display:block;padding:0 10px;padding-bottom:calc(25px + 70px)}.attendance-page__main .ant-btn-submit{margin-top:15px}", ""]);

